import http from '@/http'

const URL = '/admin/settings/financial-control'

export const getFinancialSettings = () => http.get(URL)
export const saveFinancialSettings = (payload) => http.put(URL, payload)

export default {
  getFinancialSettings,
  saveFinancialSettings
}
